export default function submenu() {
	if (document.getElementById('js-page-content') != null) {
		(function(targetId, headingTag) {
			var target = document.getElementById('js-submenu');
			var headings = document
				.getElementById('js-page-content')
				.getElementsByTagName('h2');

			if (typeof target != 'undefined' && target != null) {
				if (headings.length > 1) {
					// construct an ordered list of links
					var menuList = document.createElement('OL');
					for (var i = 0; i < headings.length; i++) {
						var anchorName = '';
						if (headings[i].id) {
							anchorName = headings[i].id;
						} else {
							anchorName = headings[i].innerText
								.toLowerCase()
								.replace(
									/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi,
									'-'
								)
								.replace(/ +/g, '-');
							headings[i].setAttribute('id', anchorName);
						}

						var headingText = headings[i].innerText;

						var menuLink = document.createElement('A');
						menuLink.setAttribute('href', '#' + anchorName);
						menuLink.appendChild(
							document.createTextNode(headingText)
						);

						var listItem = document.createElement('LI');
						listItem.appendChild(menuLink);

						menuList.appendChild(listItem);
					}

					// remove all nodes from inside target element
					while (target.hasChildNodes())
						target.removeChild(target.firstChild);

					// insert our generated menu into the target element
					target.appendChild(menuList);
				} else {
					// remove the target element from the DOM
					target.parentNode.removeChild(target);
				}
			}
		})('js-page-content', 'h2');
	}
}

submenu();
